/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotChatLogPageResponse,
  ApiEnvelopeBotChatLogSearchResponse,
  ApiEnvelopeBotProxyAssignmentDto,
  ApiEnvelopeBotRegistryAdminListResponse,
  ApiEnvelopeBotRegistryDetailResponse,
  ApiEnvelopeBotRegistryLinkInitiateResponse,
  ApiEnvelopeBotRegistryListResponse,
  ApiEnvelopeBotRegistrySimpleAckResponse,
  ApiEnvelopeBotRegistryVotingResponse,
  BotRegistryGetChatLogParams,
  BotRegistryListBotsParams,
  BotRegistrySearchChatLogParams,
  CopyBotSettingsRequest,
  LinkBotRequest,
  SetBotExternalProxyRequest,
  SetBotProxyRequest,
  SetBotVotingRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botRegistryListBotsResponse200 = {
  data: ApiEnvelopeBotRegistryListResponse
  status: 200
}

export type botRegistryListBotsResponse401 = {
  data: ApiEnvelopeBotRegistryListResponse
  status: 401
}

export type botRegistryListBotsResponse403 = {
  data: ApiEnvelopeBotRegistryListResponse
  status: 403
}

export type botRegistryListBotsResponseSuccess = (botRegistryListBotsResponse200) & {
  headers: Headers;
};
export type botRegistryListBotsResponseError = (botRegistryListBotsResponse401 | botRegistryListBotsResponse403) & {
  headers: Headers;
};

export type botRegistryListBotsResponse = (botRegistryListBotsResponseSuccess | botRegistryListBotsResponseError)

export const getBotRegistryListBotsUrl = (params?: BotRegistryListBotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botregistry?${stringifiedParams}` : `/api/botregistry`
}

export const useBotRegistryListBotsHook = (): (params?: BotRegistryListBotsParams, options?: RequestInit) => Promise<botRegistryListBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: BotRegistryListBotsParams, options?: RequestInit) => {

        return customFetcher(getBotRegistryListBotsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botRegistryListAllBotsForAdminResponse200 = {
  data: ApiEnvelopeBotRegistryAdminListResponse
  status: 200
}

export type botRegistryListAllBotsForAdminResponse401 = {
  data: ApiEnvelopeBotRegistryAdminListResponse
  status: 401
}

export type botRegistryListAllBotsForAdminResponse403 = {
  data: ApiEnvelopeBotRegistryAdminListResponse
  status: 403
}

export type botRegistryListAllBotsForAdminResponseSuccess = (botRegistryListAllBotsForAdminResponse200) & {
  headers: Headers;
};
export type botRegistryListAllBotsForAdminResponseError = (botRegistryListAllBotsForAdminResponse401 | botRegistryListAllBotsForAdminResponse403) & {
  headers: Headers;
};

export type botRegistryListAllBotsForAdminResponse = (botRegistryListAllBotsForAdminResponseSuccess | botRegistryListAllBotsForAdminResponseError)

export const getBotRegistryListAllBotsForAdminUrl = () => {




  return `/api/botregistry/admin/all`
}

export const useBotRegistryListAllBotsForAdminHook = (): ( options?: RequestInit) => Promise<botRegistryListAllBotsForAdminResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotRegistryListAllBotsForAdminUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botRegistryGetBotResponse200 = {
  data: ApiEnvelopeBotRegistryDetailResponse
  status: 200
}

export type botRegistryGetBotResponse401 = {
  data: ApiEnvelopeBotRegistryDetailResponse
  status: 401
}

export type botRegistryGetBotResponse403 = {
  data: ApiEnvelopeBotRegistryDetailResponse
  status: 403
}

export type botRegistryGetBotResponse404 = {
  data: ApiEnvelopeBotRegistryDetailResponse
  status: 404
}

export type botRegistryGetBotResponseSuccess = (botRegistryGetBotResponse200) & {
  headers: Headers;
};
export type botRegistryGetBotResponseError = (botRegistryGetBotResponse401 | botRegistryGetBotResponse403 | botRegistryGetBotResponse404) & {
  headers: Headers;
};

export type botRegistryGetBotResponse = (botRegistryGetBotResponseSuccess | botRegistryGetBotResponseError)

export const getBotRegistryGetBotUrl = (id: string,) => {




  return `/api/botregistry/${id}`
}

export const useBotRegistryGetBotHook = (): (id: string, options?: RequestInit) => Promise<botRegistryGetBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotRegistryGetBotUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botRegistryDeleteBotRegistryResponse200 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 200
}

export type botRegistryDeleteBotRegistryResponse400 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 400
}

export type botRegistryDeleteBotRegistryResponse401 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 401
}

export type botRegistryDeleteBotRegistryResponse403 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 403
}

export type botRegistryDeleteBotRegistryResponse404 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 404
}

export type botRegistryDeleteBotRegistryResponseSuccess = (botRegistryDeleteBotRegistryResponse200) & {
  headers: Headers;
};
export type botRegistryDeleteBotRegistryResponseError = (botRegistryDeleteBotRegistryResponse400 | botRegistryDeleteBotRegistryResponse401 | botRegistryDeleteBotRegistryResponse403 | botRegistryDeleteBotRegistryResponse404) & {
  headers: Headers;
};

export type botRegistryDeleteBotRegistryResponse = (botRegistryDeleteBotRegistryResponseSuccess | botRegistryDeleteBotRegistryResponseError)

export const getBotRegistryDeleteBotRegistryUrl = (id: string,) => {




  return `/api/botregistry/${id}`
}

export const useBotRegistryDeleteBotRegistryHook = (): (id: string, options?: RequestInit) => Promise<botRegistryDeleteBotRegistryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotRegistryDeleteBotRegistryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type botRegistrySetVotingResponse200 = {
  data: ApiEnvelopeBotRegistryVotingResponse
  status: 200
}

export type botRegistrySetVotingResponse400 = {
  data: ApiEnvelopeBotRegistryVotingResponse
  status: 400
}

export type botRegistrySetVotingResponse401 = {
  data: ApiEnvelopeBotRegistryVotingResponse
  status: 401
}

export type botRegistrySetVotingResponse403 = {
  data: ApiEnvelopeBotRegistryVotingResponse
  status: 403
}

export type botRegistrySetVotingResponse404 = {
  data: ApiEnvelopeBotRegistryVotingResponse
  status: 404
}

export type botRegistrySetVotingResponseSuccess = (botRegistrySetVotingResponse200) & {
  headers: Headers;
};
export type botRegistrySetVotingResponseError = (botRegistrySetVotingResponse400 | botRegistrySetVotingResponse401 | botRegistrySetVotingResponse403 | botRegistrySetVotingResponse404) & {
  headers: Headers;
};

export type botRegistrySetVotingResponse = (botRegistrySetVotingResponseSuccess | botRegistrySetVotingResponseError)

export const getBotRegistrySetVotingUrl = (id: string,) => {




  return `/api/botregistry/${id}/voting`
}

export const useBotRegistrySetVotingHook = (): (id: string,
    setBotVotingRequest?: SetBotVotingRequest, options?: RequestInit) => Promise<botRegistrySetVotingResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    setBotVotingRequest?: SetBotVotingRequest, options?: RequestInit) => {

        return customFetcher(getBotRegistrySetVotingUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setBotVotingRequest)
  }
);
      }
  }


export type botRegistryGetChatLogResponse200 = {
  data: ApiEnvelopeBotChatLogPageResponse
  status: 200
}

export type botRegistryGetChatLogResponse401 = {
  data: ApiEnvelopeBotChatLogPageResponse
  status: 401
}

export type botRegistryGetChatLogResponse403 = {
  data: ApiEnvelopeBotChatLogPageResponse
  status: 403
}

export type botRegistryGetChatLogResponse404 = {
  data: ApiEnvelopeBotChatLogPageResponse
  status: 404
}

export type botRegistryGetChatLogResponseSuccess = (botRegistryGetChatLogResponse200) & {
  headers: Headers;
};
export type botRegistryGetChatLogResponseError = (botRegistryGetChatLogResponse401 | botRegistryGetChatLogResponse403 | botRegistryGetChatLogResponse404) & {
  headers: Headers;
};

export type botRegistryGetChatLogResponse = (botRegistryGetChatLogResponseSuccess | botRegistryGetChatLogResponseError)

export const getBotRegistryGetChatLogUrl = (id: string,
    params?: BotRegistryGetChatLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botregistry/${id}/chatlog?${stringifiedParams}` : `/api/botregistry/${id}/chatlog`
}

export const useBotRegistryGetChatLogHook = (): (id: string,
    params?: BotRegistryGetChatLogParams, options?: RequestInit) => Promise<botRegistryGetChatLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: BotRegistryGetChatLogParams, options?: RequestInit) => {

        return customFetcher(getBotRegistryGetChatLogUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botRegistrySearchChatLogResponse200 = {
  data: ApiEnvelopeBotChatLogSearchResponse
  status: 200
}

export type botRegistrySearchChatLogResponse401 = {
  data: ApiEnvelopeBotChatLogSearchResponse
  status: 401
}

export type botRegistrySearchChatLogResponse403 = {
  data: ApiEnvelopeBotChatLogSearchResponse
  status: 403
}

export type botRegistrySearchChatLogResponse404 = {
  data: ApiEnvelopeBotChatLogSearchResponse
  status: 404
}

export type botRegistrySearchChatLogResponseSuccess = (botRegistrySearchChatLogResponse200) & {
  headers: Headers;
};
export type botRegistrySearchChatLogResponseError = (botRegistrySearchChatLogResponse401 | botRegistrySearchChatLogResponse403 | botRegistrySearchChatLogResponse404) & {
  headers: Headers;
};

export type botRegistrySearchChatLogResponse = (botRegistrySearchChatLogResponseSuccess | botRegistrySearchChatLogResponseError)

export const getBotRegistrySearchChatLogUrl = (id: string,
    params?: BotRegistrySearchChatLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botregistry/${id}/chatlog/search?${stringifiedParams}` : `/api/botregistry/${id}/chatlog/search`
}

export const useBotRegistrySearchChatLogHook = (): (id: string,
    params?: BotRegistrySearchChatLogParams, options?: RequestInit) => Promise<botRegistrySearchChatLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: BotRegistrySearchChatLogParams, options?: RequestInit) => {

        return customFetcher(getBotRegistrySearchChatLogUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botRegistryCopySettingsResponse200 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 200
}

export type botRegistryCopySettingsResponse401 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 401
}

export type botRegistryCopySettingsResponse403 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 403
}

export type botRegistryCopySettingsResponse404 = {
  data: ApiEnvelopeBotRegistrySimpleAckResponse
  status: 404
}

export type botRegistryCopySettingsResponseSuccess = (botRegistryCopySettingsResponse200) & {
  headers: Headers;
};
export type botRegistryCopySettingsResponseError = (botRegistryCopySettingsResponse401 | botRegistryCopySettingsResponse403 | botRegistryCopySettingsResponse404) & {
  headers: Headers;
};

export type botRegistryCopySettingsResponse = (botRegistryCopySettingsResponseSuccess | botRegistryCopySettingsResponseError)

export const getBotRegistryCopySettingsUrl = (id: string,) => {




  return `/api/botregistry/${id}/copy-settings`
}

export const useBotRegistryCopySettingsHook = (): (id: string,
    copyBotSettingsRequest?: CopyBotSettingsRequest, options?: RequestInit) => Promise<botRegistryCopySettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    copyBotSettingsRequest?: CopyBotSettingsRequest, options?: RequestInit) => {

        return customFetcher(getBotRegistryCopySettingsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(copyBotSettingsRequest)
  }
);
      }
  }


export type botRegistryLinkNewBotResponse200 = {
  data: ApiEnvelopeBotRegistryLinkInitiateResponse
  status: 200
}

export type botRegistryLinkNewBotResponse400 = {
  data: ApiEnvelopeBotRegistryLinkInitiateResponse
  status: 400
}

export type botRegistryLinkNewBotResponse401 = {
  data: ApiEnvelopeBotRegistryLinkInitiateResponse
  status: 401
}

export type botRegistryLinkNewBotResponseSuccess = (botRegistryLinkNewBotResponse200) & {
  headers: Headers;
};
export type botRegistryLinkNewBotResponseError = (botRegistryLinkNewBotResponse400 | botRegistryLinkNewBotResponse401) & {
  headers: Headers;
};

export type botRegistryLinkNewBotResponse = (botRegistryLinkNewBotResponseSuccess | botRegistryLinkNewBotResponseError)

export const getBotRegistryLinkNewBotUrl = () => {




  return `/api/botregistry/link`
}

export const useBotRegistryLinkNewBotHook = (): (linkBotRequest?: LinkBotRequest, options?: RequestInit) => Promise<botRegistryLinkNewBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (linkBotRequest?: LinkBotRequest, options?: RequestInit) => {

        return customFetcher(getBotRegistryLinkNewBotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkBotRequest)
  }
);
      }
  }


export type botRegistryLinkNewBedrockBotResponse200 = {
  data: ApiEnvelopeBotRegistryLinkInitiateResponse
  status: 200
}

export type botRegistryLinkNewBedrockBotResponse400 = {
  data: ApiEnvelopeBotRegistryLinkInitiateResponse
  status: 400
}

export type botRegistryLinkNewBedrockBotResponse401 = {
  data: ApiEnvelopeBotRegistryLinkInitiateResponse
  status: 401
}

export type botRegistryLinkNewBedrockBotResponse403 = {
  data: ApiEnvelopeBotRegistryLinkInitiateResponse
  status: 403
}

export type botRegistryLinkNewBedrockBotResponseSuccess = (botRegistryLinkNewBedrockBotResponse200) & {
  headers: Headers;
};
export type botRegistryLinkNewBedrockBotResponseError = (botRegistryLinkNewBedrockBotResponse400 | botRegistryLinkNewBedrockBotResponse401 | botRegistryLinkNewBedrockBotResponse403) & {
  headers: Headers;
};

export type botRegistryLinkNewBedrockBotResponse = (botRegistryLinkNewBedrockBotResponseSuccess | botRegistryLinkNewBedrockBotResponseError)

export const getBotRegistryLinkNewBedrockBotUrl = () => {




  return `/api/botregistry/link-bedrock`
}

export const useBotRegistryLinkNewBedrockBotHook = (): (linkBotRequest?: LinkBotRequest, options?: RequestInit) => Promise<botRegistryLinkNewBedrockBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (linkBotRequest?: LinkBotRequest, options?: RequestInit) => {

        return customFetcher(getBotRegistryLinkNewBedrockBotUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(linkBotRequest)
  }
);
      }
  }


export type botRegistryGetProxyAssignmentResponse200 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 200
}

export type botRegistryGetProxyAssignmentResponse401 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 401
}

export type botRegistryGetProxyAssignmentResponse403 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 403
}

export type botRegistryGetProxyAssignmentResponse404 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 404
}

export type botRegistryGetProxyAssignmentResponseSuccess = (botRegistryGetProxyAssignmentResponse200) & {
  headers: Headers;
};
export type botRegistryGetProxyAssignmentResponseError = (botRegistryGetProxyAssignmentResponse401 | botRegistryGetProxyAssignmentResponse403 | botRegistryGetProxyAssignmentResponse404) & {
  headers: Headers;
};

export type botRegistryGetProxyAssignmentResponse = (botRegistryGetProxyAssignmentResponseSuccess | botRegistryGetProxyAssignmentResponseError)

export const getBotRegistryGetProxyAssignmentUrl = (id: string,) => {




  return `/api/botregistry/${id}/proxy`
}

export const useBotRegistryGetProxyAssignmentHook = (): (id: string, options?: RequestInit) => Promise<botRegistryGetProxyAssignmentResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotRegistryGetProxyAssignmentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botRegistrySetProxyResponse200 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 200
}

export type botRegistrySetProxyResponse400 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 400
}

export type botRegistrySetProxyResponse401 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 401
}

export type botRegistrySetProxyResponse403 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 403
}

export type botRegistrySetProxyResponse404 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 404
}

export type botRegistrySetProxyResponseSuccess = (botRegistrySetProxyResponse200) & {
  headers: Headers;
};
export type botRegistrySetProxyResponseError = (botRegistrySetProxyResponse400 | botRegistrySetProxyResponse401 | botRegistrySetProxyResponse403 | botRegistrySetProxyResponse404) & {
  headers: Headers;
};

export type botRegistrySetProxyResponse = (botRegistrySetProxyResponseSuccess | botRegistrySetProxyResponseError)

export const getBotRegistrySetProxyUrl = (id: string,) => {




  return `/api/botregistry/${id}/proxy`
}

export const useBotRegistrySetProxyHook = (): (id: string,
    setBotProxyRequest?: SetBotProxyRequest, options?: RequestInit) => Promise<botRegistrySetProxyResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    setBotProxyRequest?: SetBotProxyRequest, options?: RequestInit) => {

        return customFetcher(getBotRegistrySetProxyUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setBotProxyRequest)
  }
);
      }
  }


export type botRegistrySetExternalProxyResponse200 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 200
}

export type botRegistrySetExternalProxyResponse400 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 400
}

export type botRegistrySetExternalProxyResponse401 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 401
}

export type botRegistrySetExternalProxyResponse403 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 403
}

export type botRegistrySetExternalProxyResponse404 = {
  data: ApiEnvelopeBotProxyAssignmentDto
  status: 404
}

export type botRegistrySetExternalProxyResponseSuccess = (botRegistrySetExternalProxyResponse200) & {
  headers: Headers;
};
export type botRegistrySetExternalProxyResponseError = (botRegistrySetExternalProxyResponse400 | botRegistrySetExternalProxyResponse401 | botRegistrySetExternalProxyResponse403 | botRegistrySetExternalProxyResponse404) & {
  headers: Headers;
};

export type botRegistrySetExternalProxyResponse = (botRegistrySetExternalProxyResponseSuccess | botRegistrySetExternalProxyResponseError)

export const getBotRegistrySetExternalProxyUrl = (id: string,) => {




  return `/api/botregistry/${id}/external-proxy`
}

export const useBotRegistrySetExternalProxyHook = (): (id: string,
    setBotExternalProxyRequest?: SetBotExternalProxyRequest, options?: RequestInit) => Promise<botRegistrySetExternalProxyResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    setBotExternalProxyRequest?: SetBotExternalProxyRequest, options?: RequestInit) => {

        return customFetcher(getBotRegistrySetExternalProxyUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setBotExternalProxyRequest)
  }
);
      }
  }


